import { MomentModule } from 'ngx-moment';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ROUTES } from './app-routing';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './directives/spinner/spinner.component';
import { AutenticacionGuard } from './auth-guard/autenticacion.guard';
import { HttpRequestInterceptor } from './interceptors/http-request.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectivePreload } from './directives/preload/selective-preload';
import { PrivilegiosGuard } from './auth-guard/privilegios.guard';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SeguridadService } from './modules/login/seguridad.service';
import localeEsHN from '@angular/common/locales/es-CO';
import { registerLocaleData } from '@angular/common';
import { NoDataPipe } from './pipes/no-data.pipe';

registerLocaleData( localeEsHN );


/**
 * Modulo principal de la aplicacion, contiene
 * todos los componentes y modulos de inicio
 */
@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent
  ],
  imports: [
    RouterModule.forRoot(ROUTES, { preloadingStrategy: SelectivePreload,  }),
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    SelectivePreload,
    AutenticacionGuard,
    PrivilegiosGuard,
    SeguridadService,
    {
      provide: LOCALE_ID, useValue: 'es-CO'
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
